import { createSelector } from 'helpers/reselect'

export const getPromotionModalShown = ({ promotionModal: { shown }}) => shown

export const getPromotionModalShownData = createSelector(
  [getPromotionModalShown],
  shown => shown
)
